import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { UniversalSearchService } from '../../../../universal-search/services/universal-search.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CustomFiltersService } from '../../../../services/custom-filters.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { Subject } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AdminService } from '../../../../admin/admin.service';

@Component({
  selector: 'app-unit-filter',
  templateUrl: './unit-filter.component.html',
  styleUrls: ['./unit-filter.component.scss'],
  imports: [
    MatTooltipModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
})
export class UnitFilterComponent implements OnInit, OnDestroy {
  private ss = inject(SessionStorageService);
  private adminService = inject(AdminService);
  usServ = inject(UniversalSearchService);
  cstmFltrSrvc = inject(CustomFiltersService);

  @Input() field;
  @Input() filterForm;
  @Input() groupKey;
  @Input() gridName: string;
  @Output() selectionChange = new EventEmitter();
  @Output() clearFilter = new EventEmitter();
  unitControl = new FormControl<any>('');
  unsubscribe = new Subject();
  dropdownLoading: boolean;
  globals = this.ss.get('globals');
  dropdownNoResults: boolean;
  previousSelectedVal = '';

  ngOnInit(): void {
    this.unitControl =
      this.filterForm.controls[this.groupKey].controls[this.field.varName];
    this.unitControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(value => {
        if (value && value.length >= 1) {
          this.dropdownLoading = true;
          this.getUnitList(value);
        }
      });

    this.cstmFltrSrvc.updateDropdowns$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: field => {
          if (field) {
            if (
              field['values']?.['field'] === this.field.varName &&
              (typeof field['values']?.['value'] === 'number' ||
                field['values']?.['value'])
            ) {
              this.unitControl.setValue(field['values']?.['value']);
              this.previousSelectedVal = field['values']?.['value'];
            } else if (
              field['varName'] === this.field.varName &&
              !field['values']?.['value']
            ) {
              this.previousSelectedVal = '';
              this.unitControl.setValue('');
            }

            if (
              this.field.conditionalField &&
              field['varName'] === this.field.conditionalField &&
              field?.['values']?.['value'] &&
              (field['values']['value'] === this.field.conditionalValue ||
                field['values']['value'].includes(this.field.conditionalValue))
            ) {
              this.unitControl.enable();
            }
          }
        },
        error: error => alert(error),
      });

    if (this.field.conditionalField) {
      this.cstmFltrSrvc.updateConditionalFilter$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: passedFilter => {
            if (
              passedFilter['varName'] === this.field.conditionalField &&
              (passedFilter['values'] === this.field.conditionalValue ||
                passedFilter['values'].includes(this.field.conditionalValue))
            ) {
              this.unitControl.enable();
            } else if (
              passedFilter['varName'] === this.field.conditionalField &&
              (passedFilter['values'] !== this.field.conditionalValue ||
                !passedFilter['values'].includes(this.field.conditionalValue))
            ) {
              const resetEvent = new PointerEvent('pointerdown');
              this.resetFilter(resetEvent);
              this.unitControl.disable();
            }
          },
          error: error => console.error('Error: ', error),
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  onBlur(ev) {
    if (ev.target.value === '') {
      this.unitControl.setValue(this.previousSelectedVal);
    }
  }

  changeSelection(ev) {
    this.previousSelectedVal = ev.option.value;
    this.selectionChange.emit(ev);
  }

  resetFilter(ev) {
    if (this.unitControl['value']) {
      this.previousSelectedVal = '';
      this.unitControl.setValue('');
    }
    this.clearFilter.emit(ev);
  }

  getUnitList(searchString?: string) {
    this.adminService.getUnitList(searchString, true).subscribe(resp => {
      this.dropdownNoResults = true;
      const newUnitList = resp.names.map(rep => ({
        value: rep.id,
        display: rep.name,
      }));
      this.field.fullField.externalFilter['options'] = newUnitList;
      if (this.field.fullField.externalFilter['options'].length > 0) {
        this.dropdownNoResults = false;
      }
      this.dropdownLoading = false;
    });
  }

  getDropdownOptions() {
    return this.field.fullField.externalFilter['options'] || [];
  }

  showClearButton(fieldName) {
    if (
      this.filterForm.controls[this.groupKey].controls[fieldName].value ||
      this.previousSelectedVal
    ) {
      return true;
    }
    return false;
  }
}
